const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('./storeLocator/storeLocator'));
});
